module.exports = __webpack_public_path__ + "img/四川天府新区幸福麓山幼儿园.3b29c782.jpg";